module.exports = __webpack_public_path__ + "images/seat_small6112ce7cda7fcf5745db35a13af6a650.png";